module.exports = __webpack_public_path__ + "img/LG.bb030a1b.png";